import { useCallback } from "react";
import { didRequestReachServer } from "@api/apiError";
import { useToaster } from "@design-system/ToastMessages/useToaster";

export function useCancelTransferRequest() {
    const { toast, error: showError } = useToaster();

    return useCallback(
        async <T>({
            cancel,
            successMessage,
            errorMessage,
        }: {
            cancel: () => Promise<T>;
            successMessage: string;
            errorMessage: string;
        }) => {
            try {
                await cancel();
                toast(successMessage);
            } catch (error) {
                if (!didRequestReachServer(error)) {
                    showError(errorMessage);
                }
            }
        },
        [toast, showError],
    );
}
